'use client';

/**
 * 공유 링크 복사 — 공유 페이지 경로(`/share/...`)를 이 사이트 주소로 붙여 복사하고 토스트로 알린다.
 *
 * 🔑 소재 찾기 · 브랜드 허브 · 크리에이터 허브가 **같은 말**을 쓴다(「공유 링크를 복사했습니다.」).
 * 복사 자체는 `utils/clipboard/copy-text` 가 한다(보안 연결이 아닐 때의 갈래를 그쪽이 쥔다).
 * 누르면 `share_clicked` 하나를 남긴다 — 어느 자리인지는 `uiId` 가 가른다.
 */

import { useCallback } from 'react';

import { copyText } from 'src/utils/clipboard/copy-text';

import { track } from 'src/lib/analytics/client';

import { toast } from 'src/components/snackbar';

/** @returns `(path, uiId)` — 경로가 비면 복사하지 않고 실패를 알린다 */
export function useCopyShareLink() {
  return useCallback((path: string, uiId: string) => {
    if (!path) {
      toast.error('링크를 복사하지 못했습니다.');
      return;
    }
    track({ name: 'share_clicked', type: 'action', props: {} }, { uiId });
    copyText(`${window.location.origin}${path}`).then((ok) => (ok ? toast.success('공유 링크를 복사했습니다.') : toast.error('링크를 복사하지 못했습니다.')));
  }, []);
}
